import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SearchReqResponse, SearchService} from "../../services/search-service";
import {DropdownConfig, DropdownOption} from "../custom-dropdown/custom-dropdown.component";
import {NewReleaseResult} from "../../models/newReleaseResult";
import {
  DEFAULT_STICKY_CONFIG,
  StickyConfig,
  StickyLink,
  StickyLinkGroup,
  StickyLinkType
} from "../sticky-tabs/sticky-tabs.component";
import {BYOTermResponse} from "../../models/byoTermResponse";
import {Router} from "@angular/router";
import {Registration} from "../../models/registration";
import {PlateDetail} from "../../models/plateDetail";

export class NewReleaseDropdownOptions {
  public prefix: { four_letter: string[], three_letter: string[] }
  public suffix: { four_letter: string[], three_letter: string[] }
}

@Component({
  selector: 'pla-new-release-search',
  templateUrl: './new-release-search.component.html',
  styleUrls: ['./new-release-search.component.scss']
})
export class NewReleaseSearchComponent implements OnInit {

  public viewMode: 'custom-dropdown' | 'autocomplete' | 'plate' | 'new-dropdown' = 'new-dropdown';

  @Input() public searchByPrefix: boolean = true;
  @Input() public year: string = '';
  @Output() public byoOutput: EventEmitter<{prefix: boolean, value: string}> = new EventEmitter<{prefix: boolean, value: string}>();
  public loading: boolean = false;
  public showPrices: boolean = true;

  public detail: {
    min: number;
    max: number;
    lastUpdate: Date;
    plateDetail: PlateDetail;
    loaded: boolean;
  } = {
    min: 0,
    max: 0,
    lastUpdate: new Date(),
    plateDetail: undefined,
    loaded: false
  };

  public visibleOptions: string = 'three-letter-prefix';
  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup([
        new StickyLink('3 Letter Starts', 'three-letter-prefix', true, StickyLinkType.ACTION, null, false, (link) => { this.page = 1; this.visibleOptions = link.anchor }),
        new StickyLink('4 Letter Starts', 'four-letter-prefix', false, StickyLinkType.ACTION, null, false, (link) => { this.page = 1; this.visibleOptions = link.anchor }),
        new StickyLink('4 Letter Endings', 'four-letter-suffix', false, StickyLinkType.ACTION, null, false, (link) => { this.page = 1; this.visibleOptions = link.anchor })
      ].filter(x => x != null)),
    ],
    new EventEmitter<void>(),
    { ...DEFAULT_STICKY_CONFIG, changeOnScroll: false }
  );

  public prefixFilter: string = ''
  public prefixDropdownOption: DropdownOption = null;
  public changePrefixDropdown: EventEmitter<DropdownOption | null> = new EventEmitter<DropdownOption | null>();
  public prefixOptions: DropdownConfig = new DropdownConfig('Select a start', 'swap_vert', [
  ], { showSelected: true, selectOnStart: true });
  public selectedPrefix: string = '';

  public suffixFilter: string = ''
  public suffixDropdownOption: DropdownOption = null
  public changeSuffixDropdown: EventEmitter<DropdownOption | null> = new EventEmitter<DropdownOption | null>();
  public suffixOptions: DropdownConfig = new DropdownConfig('Select an ending', 'swap_vert', [
  ], { showSelected: true, selectOnStart: true });
  public selectedSuffix: string = '';

  public paginationSize: number = 20;
  public page: number = 1;
  public results: NewReleaseResult[] = [];

  public seriesBYO: BYOTermResponse;
  public byoLoading: boolean = false;
  public byoResults: SearchReqResponse;
  public byoResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  constructor(private router: Router, private searchService: SearchService) { }

  ngOnInit(): void {
      this.searchService.getNewReleaseWordOptions(this.year, (res: NewReleaseDropdownOptions) => {
        this.prefixOptions = new DropdownConfig('Select a start', 'swap_vert', [
          ...res.prefix.three_letter.map(s=> new DropdownOption(s, s)),
          ...res.prefix.four_letter.map(s=> new DropdownOption(s, s))
        ], { showSelected: true, selectOnStart: true });

        this.suffixOptions = new DropdownConfig('Select an ending', 'swap_vert', [
          ...res.suffix.three_letter.map(s=> new DropdownOption(s, s)),
          ...res.suffix.four_letter.map(s=> new DropdownOption(s, s))
        ], { showSelected: true, selectOnStart: true });


        if (this.viewMode === 'new-dropdown') {
          if (this.searchByPrefix) {
            this.PlateOptionChange(true, {rawPlate: res.prefix.four_letter[0]});
            this.selectedSuffix = this.suffixConfig(3).options[0].value;
          } else {
            this.PlateOptionChange(false, {rawPlate: res.suffix.three_letter[0]});
            this.selectedSuffix = this.suffixConfig(4).options[0].value;
          }
        } else {
          this.PlateOptionChange(true, {rawPlate: res.prefix.three_letter[0]});
        }
      });

    this.seriesBYO = new BYOTermResponse().construct();
    this.seriesBYO.current.construct(
      'current',
      '',
      this.year.toString(),
      ''
    );
  }

  public handleByoResultChange(res: { loading: boolean,  results: SearchReqResponse}): void {
    this.byoLoading = res.loading;
    this.byoResults = res.results;
    this.byoResultChange.emit(res.results);
  }

  public byoUpdated(res: { prefix: boolean, value: string }): void {
    console.log(res);
    this.seriesBYO = null
    setTimeout(() => {
      this.seriesBYO = new BYOTermResponse().construct();
      this.seriesBYO.current.construct(
        'current',
        res.prefix ? res.value.substring(0, 2) : '',
        this.year.toString(),
        res.prefix ? '' : res.value.slice(-3),
      );
    }, 200);
  }

  public lengthOptions(prefix: boolean, length: number): DropdownOption[] {
    return prefix ?
      [...this.prefixOptions.options.filter(o => o.value.length === length)].splice(0, this.paginationSize * this.page)
        : [...this.suffixOptions.options.filter(o => o.value.length === length)].splice(0, this.paginationSize * this.page)
  }

  public getOptions(prefix: boolean): DropdownOption[] {
    return prefix ?
      [...this.prefixOptions.options.filter(o => o.value.toUpperCase().indexOf(this.prefixFilter.toUpperCase()) > -1)] :
      [...this.suffixOptions.options.filter(o => o.value.toUpperCase().indexOf(this.suffixFilter.toUpperCase()) > -1)];
  }

  public hasMore(prefix: boolean, length: number): boolean {
    const options = prefix ?
      [...this.prefixOptions.options.filter(o => o.value.length === length)] :
      [...this.suffixOptions.options.filter(o => o.value.length === length)];
    return options.length > this.paginationSize * this.page;
  }

  public PageIncrease(): void {
    this.page++;
  }

  public OptionChange(prefix: boolean, e: DropdownOption, emptyOpposite: boolean = true): void {
    if (e == null) return;
    this.page = 1;
    if (prefix) {
      this.selectedPrefix = e.value;
      if (emptyOpposite) {
        this.selectedSuffix = null;
        this.changeSuffixDropdown.emit(null);
      }
      this.prefixDropdownOption = e;
    } else {
      this.selectedSuffix = e.value;
      this.suffixDropdownOption = e;
      if (emptyOpposite) {
        this.selectedPrefix = null;
        this.changePrefixDropdown.emit(null);
      }
    }

    if (!emptyOpposite) {
      this.showPrices = false;
      this.detail = null
      setTimeout(() => {
        this.showPrices = true;
      }, 50)
    }

    this.SearchResults(prefix);
  }

  public RawOptionChange(prefix: boolean, changeEvent: any): void {
    this.page = 1;
    if (prefix) {
      this.suffixFilter = '';
      this.prefixDropdownOption = this.prefixOptions.options.find(o => o.value === changeEvent.option.value);
      this.suffixDropdownOption = null;
      this.selectedPrefix = this.prefixDropdownOption.value;
      this.selectedSuffix = null;

      if (this.prefixDropdownOption) this.SearchResults(prefix);
    } else {
      this.prefixFilter = '';
      this.prefixDropdownOption = null;
      this.suffixDropdownOption = this.suffixOptions.options.find(o => o.value === changeEvent.option.value);
      this.selectedSuffix = this.suffixDropdownOption.value;
      this.selectedPrefix = null;

      if (this.suffixDropdownOption) this.SearchResults(prefix);
    }
  }

  public prefixConfig(length: number): DropdownConfig {
    const options = this.prefixOptions.options.filter(o => o.value.length === length);
    return { ...this.prefixOptions, options: options };
  }

  public suffixConfig(length: number): DropdownConfig {
    const options = this.suffixOptions.options.filter(o => o.value.length === length);
    return { ...this.suffixOptions, options: options };
  }

  public PlateOptionChange(prefix: boolean, event: any, emptyOpposite: boolean = true): void {
    const rawPlate = event.rawPlate.replace('____', '').replace('___', '').replace('__', '').replace('_', '');
    if (prefix) {
      this.prefixDropdownOption = this.prefixOptions.options.find(o => o.value === rawPlate);
      this.selectedPrefix = rawPlate;
      if (emptyOpposite) {
        this.suffixDropdownOption = null;
        this.selectedSuffix = null;
      }

      if (this.prefixDropdownOption) this.SearchResults(prefix);
    } else {
      this.suffixDropdownOption = this.suffixOptions.options.find(o => o.value === rawPlate);
      this.selectedSuffix = rawPlate;

      if (emptyOpposite) {
        this.prefixDropdownOption = null;
        this.selectedPrefix = null;
      }

      if (this.suffixDropdownOption) this.SearchResults(prefix);
    }

    if (!emptyOpposite) {
      this.showPrices = false;
      this.detail = null
      setTimeout(() => {
        this.showPrices = true;
      }, 50)
    }
  }

  public SearchResults(prefix: boolean): void {
    this.loading = true;
    const term = prefix ? this.prefixDropdownOption.value : this.suffixDropdownOption.value

    this.byoOutput.emit({ prefix: prefix, value: term });
    this.byoUpdated({ prefix: prefix, value: term });

    this.searchService.getNewReleaseWordResults(this.year, term, prefix, (res: NewReleaseResult[]) => {
      this.loading = false;
      this.results = res;
    })
  }

  public PriceRangeChange(data: { min: number; max: number }): void {
    this.detail = { ...this.detail, min: data.min, max: data.max, loaded: true };
  }

  public selectedPlate(forceNull: boolean = false): Registration {
    if (forceNull) return null;
    let plate = this.selectedPrefix + this.selectedSuffix;
    plate = plate.substring(0, 2) + this.year + ' ' + plate.substring(4);
    return new Registration(0, plate.replace(' ', ''), plate);
  }

  public openPlateDetail(): void {
    this.router.navigate([`plate-detail/${this.selectedPlate()}`]);
  }
}
